import { BaseViewStore } from 'core/stores';
import { action, observable } from "mobx";
import moment from 'moment';
class FacilityOrderNewFlowStatusBarViewStore extends BaseViewStore {
    @observable accessor isStatusBarVisible = true;
    @observable accessor activeBar = '';

    constructor(rootStore, componentProps) {
        super(rootStore);

        this.rootStore = rootStore;
        this.facilityOrder = componentProps.facilityOrder;
        this.showInventoryButton = componentProps.isInventoryStepAllowed;
        this.title = componentProps.title;
        this.statusBarRefreshCallback = componentProps.statusBarRefreshCallback;
        this.isStatusBarVisible = componentProps.isOpen;
        this.changeStatusBarVisibility = componentProps.changeStatusBarVisibility;
        let userRoles = this.rootStore.userStore.applicationUser.roles;
        this.isStatusBarAllowed = !(userRoles.includes("InitialIntake") || userRoles.includes("InsuranceReview") || componentProps.hideStatusBar);
        const isBiller = userRoles.includes("Biller");
        const isAdmin = userRoles.includes("Administrators");
        this.showBillingButton = isBiller || isAdmin;
        this.setActiveBar();
    }

    @action.bound
    async showHideStatusBar() {
        this.isStatusBarVisible = !this.isStatusBarVisible;
        if (this.changeStatusBarVisibility)
            this.changeStatusBarVisibility();
    }

    setActiveBar() {
        if (this.rootStore.routerStore.router.routerState.routeName === 'master.app.main.facility-order.facility-order-new-flow.preview') {
            this.activeBar = 'initial';
        } else if (this.rootStore.routerStore.router.routerState.routeName === 'master.app.main.facility-order.facility-order-new-flow.insurance-preview') {
            this.activeBar = 'insurance';
        } else if (this.rootStore.routerStore.router.routerState.routeName === 'master.app.main.facility-order.facility-order-new-flow.us-intake-preview') {
            this.activeBar = 'us-intake';
        } else if (this.rootStore.routerStore.router.routerState.routeName === 'master.app.main.facility-order.facility-order-new-flow.clinical-preview') {
            this.activeBar = 'clinical';
        } else if (this.rootStore.routerStore.router.routerState.routeName === 'master.app.main.facility-order.facility-order-new-flow.inventory-preview') {
            this.activeBar = 'inventory';
        } else if (this.rootStore.routerStore.router.routerState.routeName === 'master.app.main.facility-order.facility-order-new-flow.order-summary') {
            this.activeBar = 'order-summary';
        } else if (this.rootStore.routerStore.router.routerState.routeName === 'master.app.main.facility-order.facility-order-new-flow.billing.preview') {
            this.activeBar = 'billing';
        }
    }

    @action.bound
    async openPage(page) {
        if (page === "initial-intake") {
            window.open(this.rootStore.routerStore.findRoute("master.app.main.facility-order.facility-order-new-flow.preview").pattern.replace(":id", this.facilityOrder.id));
        }
        else if (page === "insurance-review") {
            window.open(this.rootStore.routerStore.findRoute("master.app.main.facility-order.facility-order-new-flow.insurance-preview").pattern.replace(":id", this.facilityOrder.id));
        }
        else if (page === "us-intake") {
            window.open(this.rootStore.routerStore.findRoute("master.app.main.facility-order.facility-order-new-flow.us-intake-preview").pattern.replace(":id", this.facilityOrder.id));
        }
        else if (page === "clinical-review") {
            window.open(this.rootStore.routerStore.findRoute("master.app.main.facility-order.facility-order-new-flow.clinical-preview").pattern.replace(":id", this.facilityOrder.id));
        }
        else if (page === "inventory") {
            window.open(this.rootStore.routerStore.findRoute("master.app.main.facility-order.facility-order-new-flow.inventory-preview").pattern.replace(":id", this.facilityOrder.id));
        }
        else if (page === "order-summary") {
            window.open(this.rootStore.routerStore.findRoute("master.app.main.facility-order.facility-order-new-flow.order-summary").pattern.replace(":id", this.facilityOrder.id));
        }
        else if (page === "billing") {
            window.open(this.rootStore.routerStore.findRoute("master.app.main.facility-order.facility-order-new-flow.billing.preview").pattern.replace(":id", this.facilityOrder.id));
        }
    }

    @action.bound
    getStatusButtonClassName(button) {
        let initialIntakeStatus = this.facilityOrder.facilityOrderStatuses.find(x => x.status && x.status.abrv === "initial-intake");
        let insuranceReviewStatus = this.facilityOrder.facilityOrderStatuses.find(x => x.status && x.status.abrv === "insurance-review");
        let usIntakeStatus = this.facilityOrder.facilityOrderStatuses.find(x => x.status && x.status.abrv === "us-intake");
        let clinicalReviewStatus = this.facilityOrder.facilityOrderStatuses.find(x => x.status && x.status.abrv === "clinical-review");
        let inventoryStatus = this.facilityOrder.facilityOrderStatuses.find(x => x.status && x.status.abrv === "inventory");
        let billingStatus = this.facilityOrder.facilityOrderStatuses.find(x => x.status && x.status.abrv === "imported");
        let orderSummary = this.facilityOrder.facilityOrderStatuses.find(x => x.status && x.status.abrv === "order-summary");

        if (button === "initial-intake") {
            if (!initialIntakeStatus) {
                if (insuranceReviewStatus || usIntakeStatus || clinicalReviewStatus) {
                    return "is-skipped";
                }
                return "is-not-started";
            } else if (initialIntakeStatus.completedOn) {
                return "is-completed";
            } else if (insuranceReviewStatus || usIntakeStatus || clinicalReviewStatus) {
                return "is-skipped";
            } else {
                return "is-in-progress";
            }
        } else if (button === "insurance-review") {
            if (!insuranceReviewStatus) {
                if (usIntakeStatus || clinicalReviewStatus) {
                    return "is-skipped";
                }
                return "is-not-started";
            } else if (insuranceReviewStatus.completedOn) {
                return "is-completed";
            } else if (usIntakeStatus || clinicalReviewStatus) {
                return "is-skipped";
            } else {
                return "is-in-progress";
            }
        }
        else if (button === "us-intake") {
            if (usIntakeStatus) {
                if (usIntakeStatus.completedOn) {
                    return "is-completed";
                }
                return "";
            }
            return "is-not-started";
        }
        else if (button === "clinical-review") {
            if (clinicalReviewStatus) {
                if (clinicalReviewStatus.completedOn) {
                    return "is-completed";
                }
                return "";
            }
            return "is-not-started";
        }
        else if (button === "inventory") {
            if (this.facilityOrder.missingInventoryCount) {
                return "is-skipped";
            }
            if (inventoryStatus) {
                if (inventoryStatus.completedOn) {
                    return "is-completed";
                }
                return "";
            }
            return "is-not-started";
        }
        else if (button === "order-summary") {
            if (orderSummary) {
                if (orderSummary.completedOn) {
                    return "is-completed";
                }
                return "";
            }
            return "is-not-started";
        }
        else if (button === "billing") {
            if (billingStatus) {
                if (billingStatus.completedOn) {
                    return "is-completed";
                }
                return "";
            }
            return "is-not-started";
        }
    }

    formatDate(dateString) {
        return moment(dateString).format("MMMM DD,YYYY, [at] hh:mmA");
    }

    @action.bound
    getUserAndDateCompleted(button) {
        let initialIntakeStatus = this.facilityOrder.facilityOrderStatuses.find(x => x.status && x.status.abrv === "initial-intake");
        let insuranceReviewStatus = this.facilityOrder.facilityOrderStatuses.find(x => x.status && x.status.abrv === "insurance-review");
        let usIntakeStatus = this.facilityOrder.facilityOrderStatuses.find(x => x.status && x.status.abrv === "us-intake");
        let clinicalReviewStatus = this.facilityOrder.facilityOrderStatuses.find(x => x.status && x.status.abrv === "clinical-review");
        let inventoryStatus = this.facilityOrder.facilityOrderStatuses.find(x => x.status && x.status.abrv === "inventory");
        let billingStatus = this.facilityOrder.facilityOrderStatuses.find(x => x.status && x.status.abrv === "imported");
        let orderSummary = this.facilityOrder.facilityOrderStatuses.find(x => x.status && x.status.abrv === "order-summary");

        if (button === "initial-intake") {
            if (initialIntakeStatus && initialIntakeStatus.completedByUser) {
                return initialIntakeStatus.completedByUser.fullName + "<br />" + this.formatDate(initialIntakeStatus.completedOn);
            }
        }
        else if (button === "insurance-review") {
            if (insuranceReviewStatus && insuranceReviewStatus.completedByUser) {
                return insuranceReviewStatus.completedByUser.fullName + "<br />" + this.formatDate(insuranceReviewStatus.completedOn);
            }
        }
        else if (button === "us-intake") {
            if (usIntakeStatus && usIntakeStatus.completedByUser) {
                return usIntakeStatus.completedByUser.fullName + "<br />" + this.formatDate(usIntakeStatus.completedOn);
            }
        }
        else if (button === "clinical-review") {
            if (clinicalReviewStatus && clinicalReviewStatus.completedByUser) {
                return clinicalReviewStatus.completedByUser.fullName + "<br />" + this.formatDate(clinicalReviewStatus.completedOn);
            }
        }
        else if (button === "inventory") {
            if (inventoryStatus && inventoryStatus.completedByUser) {
                return inventoryStatus.completedByUser.fullName + "<br />" + this.formatDate(inventoryStatus.completedOn);
            }
        }
        else if (button === "order-summary") {
            if (orderSummary && orderSummary.completedByUser) {
                return orderSummary.completedByUser.fullName + "<br />" + this.formatDate(orderSummary.completedOn);
            }
        }
        else if (button === "billing") {
            if (billingStatus && billingStatus.completedByUser) {
                return billingStatus.completedByUser.fullName + "<br />" + this.formatDate(billingStatus.completedOn);
            }
        }
    }
}

export default FacilityOrderNewFlowStatusBarViewStore;
